import React from 'react';
import './BackgroundEffects.css';

const BackgroundEffects = () => {
    return (
        <div className="background-effects-container">
            <div className="orb orb-1"></div>
            <div className="orb orb-2"></div>
            <div className="orb orb-3"></div>
            <div className="particles"></div>
        </div>
    );
};

export default BackgroundEffects;
